import Marquee from "react-fast-marquee";

const ITEMS = ["HEALTHY BODY", "CLEAN MIND", "SPORTY SPIRIT", "STRONG & SOFT"];

const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-forest/10 bg-sage/25 py-6">
    <Marquee speed={28} gradient={false}>
      {ITEMS.concat(ITEMS).map((item, i) => (
        <span key={i} className="mx-10 flex items-center gap-10">
          <span className="font-display text-2xl font-extrabold tracking-[0.15em] text-forest/70 md:text-3xl">
            {item}
          </span>
          <span className="font-serif text-2xl italic text-coral">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
